import React, { Component } from  'react';
import * as stringify from "json-stringify-pretty-compact";

class GeminiSpecSelect extends Component {

  render() {

    return <select
        id="gemspec-select"
        className="custom-select custom-select-sm mr-1"
        value={this.props.selectedSpecIndex}
        style={{maxWidth: "300px"}}
        onChange={this.onChange.bind(this)}
      >
          {
            this.props.gemSpecs.map((gemSpec, i) => {
              return <option key={i} value={i}>
                {gemSpec.meta && gemSpec.meta.name ? gemSpec.meta.name : i.toString()}
                </option>
            })
          }
      </select>
  }

  async onChange(event) {
    let value = event.target.value;
    let selectedGemSpecs = this.props.gemSpecs[value];
    let gemSpecJSON = stringify(selectedGemSpecs, null, 2);
    this.props.onSpecChange("gemSpec", gemSpecJSON);
    this.props.updateSelectedSpecIndex(value);
  }
}

export default GeminiSpecSelect;


